import { Card, Link } from "@components/ui-kit";
import { type TColumnDef, useTable } from "@components/ui-kit/table";
import { Trans, t } from "@lingui/macro";
import { TableBody } from "@src/components/modules/common/table";
import { currency, dateTime } from "@src/utils/formatters";
import cx from "classnames";
import { observer } from "mobx-react-lite";
import type { LinkProps } from "next/link";
import { useContext, useState } from "react";
import { PageCreditAccountCtx } from "../PageCreditAccountDetail";
import { StoreTableDebits } from "./StoreTableDebits";

interface IUsedIn {
  title: string;
  pathname: LinkProps["href"];
}

type TData = {
  id: string;
  date: string | null | undefined;
  usedIn: IUsedIn;
  amount: number;
};

const cols: TColumnDef<TData, any> = [
  {
    key: "date",
    header: () => t`Date`,
    render: (r) => (r.date ? dateTime.format(new Date(r.date)) : ""),
  },
  {
    key: "usedIn",
    header: () => t`Used in`,
    render: (r) => <Link href={r.usedIn.pathname}>{r.usedIn.title}</Link>,
  },
  {
    key: "amount",
    header: () => t`Amount`,
    render: (r) => {
      return (
        <span
          className={cx({
            "text-red": Math.sign(r.amount) === -1,
            "text-green": Math.sign(r.amount) === 1,
          })}
        >
          {currency.formatByWorkspace(r.amount)}
        </span>
      );
    },
  },
];

export const TableDebits = observer(function TableDebits() {
  const store = useContext(PageCreditAccountCtx);
  const [tableStore] = useState(() => new StoreTableDebits(store));

  const tableData: TData[] = tableStore.data;
  const { table, selection } = useTable(tableData, cols, {
    selectable: false,
    allRowsIds: [],
  });

  return (
    <div data-testid="card-list-debits">
      <Card>
        <div className="h-24 flex items-center justify-between px-6">
          <div className="flex items-center h-full">
            <h2 className="text-3xl font-bold mr-16">
              <Trans>Debits</Trans>
            </h2>
          </div>
        </div>
        <TableBody table={table} selection={selection} />
      </Card>
    </div>
  );
});
